import axios from 'axios';
// import qs from 'qs';
//vue-cookies
import VueCookies from 'vue-cookies';
import {Loading, Message} from 'element-ui';
import global from '../Global.vue';
import local_request from '../local_request'//引用文件

const DefaultParam = { repeatable: false };

let ajax = {
	// PREFIX: 'http://work3.com/backend/api/v1',
	PREFIX: '/api/v2',
	Author: 'xuexi.qsxueli',
	requestingApi: new Set(),
	extractUrl: function (url) {
		return url ? url.split('?')[0] : '';
	},
	isRequesting: function (url) {
		let api = this.extractUrl(url);
		return this.requestingApi.has(api);
	},
	addRequest: function (url) {
		let api = this.extractUrl(url);
		this.requestingApi.add(api);
	},
	deleteRequest: function (url) {
		let api = this.extractUrl(url);
		this.requestingApi.delete(api);
	},
	get: function (url, extendParam, param) {
		let params = {
			url,
			method: 'GET'
		}
		if (param) {
			params.params = param;
		}
		return this.ajax(params, extendParam);
	},
	post: function (url, param, extendParam) {
		var params = {
			url,
			method: 'POST'
		};
		if (param) params.data = param
		return this.ajax(params, extendParam);
	},
	postJson: function (url, paramJson, extendParam) {
		return this.ajax({
			url,
			method: 'POST',
			data: paramJson
		}, extendParam);
	},
	putJson: function (url, paramJson, extendParam) {
		return this.ajax({
			url,
			method: 'PUT',
			data: paramJson
		}, extendParam);
	},
	patchJson: function (url, paramJson, dataType, extendParam) {
		return this.ajax({
			url,
			method: 'PATCH',
			data: paramJson
		}, extendParam);
	},
	delete: function (url, extendParam) {
		return this.ajax({
			url: url,
			method: 'DELETE'
		}, extendParam);
	},
	ajax: function (param, extendParam) {
		let params = Object.assign({
			isRequesting: true,
		}, DefaultParam, param, extendParam || { load: false });
		params.crossDomain = params.url.indexOf('http') === 0;
		let url = params.url;
		if (!params.crossDomain) {
		  let origin = ''
		  if(process.env.NODE_ENV === "production"){
		    origin = window.location.hostname == 'gzxsen.com' ? 'https://gzxsen.com' : window.location.origin
		  }else{
			origin = local_request.serverSrc
		  }
		  url = params.url = origin + this.PREFIX + params.url
		}
		if (params.method != 'GET' && params.isRequesting) {
			if (this.isRequesting(url)) {
				return new Promise((resolve, reject) => { resolve({ ok: false, msg: '重复请求' }); });
			}
			if (params.repeatable === false) {
				this.addRequest(url);
			}
		}
		let header = {
			// author: this.Author,
			Authorization: VueCookies.get("token"),
			'Qs-Client-Type': localStorage.getItem('client_type'),
			// cookie: 'token=Bearer ' + VueCookies.get("token"),
			// 'X-Requested-With': 'XMLHttpRequest',
			// 'Content-Type': 'multipart/form-data',
			// 'Access-Control-Allow-Origin': '*',
			// 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		};
		let defaultParam = {
			headers: header,
			responseType: 'json',
			// validateStatus: function (status) {
			//   return true;
			// },
			// paramsSerializer: (params) => {
			//   return qs.stringify(params, { allowDots: true });
			// }
		};
		let that = this;
		params = Object.assign({}, defaultParam, params);
		// 判断是否开启全局加载动画
		let load
		if(params.load){
		load = Loading.service({
			lock: true,
			// text: 'Loading',
			// spinner: 'el-icon-loading',
			background: 'rgba(255, 255, 255, 0.7)'
		});
		}
		return new Promise((resolve) => {
			return axios.request(params).then((response) => {
				if(params.load) load.close();   // 关闭全局加载动画
				that.deleteRequest(params.url);
				let data = response.data;
				let status = response.status;
				if (status != 200) {
					// http请求错误
					Message.error('请求异常');
					return;
				}
				if (data) {
					let code = data.code;
					if (code !== 0&&code !== undefined) {
						if (code === 401) {
							// 白名单页不跳转401
							let hash = window.location.hash
							let page_whitelist = global.page_whitelist
							for(let p = 0; p < page_whitelist.length; p++){
							  let page = page_whitelist[p]
							  if(hash.indexOf(page) > -1){
								console.log('白名单页');
								return;
							  }
							}

							VueCookies.remove("token")
							Message.warning('请重新登录');
							window.top.location = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/login';
							return;
						}
						Message.error(data.message);
						resolve(Object.assign(response,{
							ok: false
						}));
						return;
					}
					data.ok = true;
					resolve(response);
				}else{
					response.ok = true
					resolve(response);
				}
			}).catch((err) => {
				console.log(err);
				that.deleteRequest(params.url);
				resolve({
					ok: false
				});
			});
		});
	}
};
export default ajax;



// WEBPACK FOOTER //
// ./src/common/ajax.js